<template>
    <div>
        <breadcrumbs
            :title="'Porezi'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Porez: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <porez-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                ></porez-forma>
            </div>
        </div>
    </div>
</template>

<script>
import PorezForma from "./PorezForma";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
export default {
    name: "PorezEdit",
    components: {
        Breadcrumbs,
        PorezForma
    },
    data(){
        return {
            id: this.$route.params.porez_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/porezi',
                    name: 'Porezi'
                },
                {
                    path: '/postavke/porezi/' + this.id,
                    name: 'Porez: ' + this.naziv
                },
                {
                    path: '/postavke/porezi/' + this.id,
                    name: 'Uredi porez: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.postotak || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
